/** 用户相关接口 */
import request from '@/utils/util.request';

/*
 *  (shop) 商户信息加载
 */
export const shop_load_data = (data) => {
	return request({
		url: '/shop/loaddata',
		data,
		loading: false,
	});
};

/*
 *  (shop) 商户信息保存
 */
export const shop_save = (data) => {
	return request({
		url: '/shop/save',
		data,
	});
};

/*
 *  (user) 修改密码
 * 	@param {string} password: (md5)
 *  @param {string} newpassword:  (md5)
 */
export const user_edit_password = (data) => {
	return request({
		url: '/user/editpassword',
		data,
	});
};

/*
 *  (wxbind) 绑定微信加载
 */
export const wxbind_load_data = (data) => {
	return request({
		url: '/wxbind/loaddata',
		data,
	});
};

/*
 *  (wxbind) 绑定微信保存
 */
export const wxbind_edit = (data) => {
	return request({
		url: '/wxbind/edit',
		data,
	});
};

/*
 *  获取用户信息(游客)
 */
export const getUser = (data) => {
	return request({
		url: '/user/loaddata',
		data,
	});
};
